import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class PreBuiltVariableService {
  /*
  * categories supported by prebuilt variables
  * the keys are appended with a 'z' to push them lower in the select box options
  */
  categories: any = {
    'zmonths': 'LABEL_PREBUILT_VARIABLE_MONTHS',
    'zdays': 'LABEL_PREBUILT_VARIABLE_DAYS',
    'zcountry': 'LABEL_PREBUILT_VARIABLE_COUNTRY',
    'zusstate': 'LABEL_PREBUILT_VARIABLE_US_STATES'
  };
  constructor() { }

  /**
   * @ngdoc method
   * @name $PrebuiltVariableService#getData
   * @methodOf wm.variables.$PrebuiltVariableService
   * @function
   *
   * @description
   * loads the prebuilt variables' data and returns it in callback
   *
   */
  getData() {
    return new Promise((resolve, reject) => {
      import(`../../../assets/resources/files/preBuiltVariableData.json`).then((res) => {
        resolve(res);
      });
    });
  }

  /**
   * @ngdoc method
   * @name $PrebuiltVariableService#getCategories
   * @methodOf wm.variables.$PrebuiltVariableService
   * @function
   *
   * @description
   * returns the categories supported by prebuilt variables
   *
   * @param {object} params contain data of the file to be read
   * @param {function} successCallback to be called on success
   * @param {function} failureCallback to be called on failure
   */
  getCategories() {
    return this.categories;
  }
}
